module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "settings includes-header"
  }, [_c('header', {
    staticClass: "page-header settings-header"
  }, [(!_vm.inModal) ? _c('router-link', {
    staticClass: "back tag button-timid left",
    attrs: {
      "to": {
        name: 'root'
      }
    }
  }, [_vm._v("x Sluiten")]) : _vm._e(), (_vm.viewingGroup) ? [_c('h1', [_vm._v("Klas " + _vm._s(_vm.viewingGroup.name))]), _c('p', [_vm._v("Instellingen van de klas")])] : [_c('h1', [_vm._v("Nieuwe klas")]), _c('p', [_vm._v("Maak een nieuwe klas voor " + _vm._s(_vm.school.name))])]], 2), _c('div', {
    staticClass: "settings-links tag"
  }, [_c('a', {
    class: {
      'is-active': _vm.isGeneralActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewGeneral($event)
      }
    }
  }, [_vm._v("Algemeen")]), _vm._v(" |\n        "), _c('a', {
    class: {
      'is-active': _vm.isPlanningActive, 'is-disabled': _vm.isCreating && !_vm.isCreated
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewPlanning($event)
      }
    }
  }, [_vm._v("Planning")]), _vm._v(" |\n        "), _c('a', {
    class: {
      'is-active': _vm.isAssignmentsActive, 'is-disabled': _vm.isCreating && !_vm.isCreated
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewAssignments($event)
      }
    }
  }, [_vm._v("Opdrachten")]), _vm._v(" |\n        "), _c('a', {
    class: {
      'is-active': _vm.isInviteActive, 'is-disabled': _vm.isCreating && !_vm.isCreated
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewInvite($event)
      }
    }
  }, [_vm._v("Leerlingen")])]), _c(_vm.view, {
    ref: "step",
    tag: "component",
    staticClass: "settings-modal-content",
    attrs: {
      "group": _vm.viewingGroup,
      "school": _vm.school,
      "isDemo": _vm.isDemo,
      "isAdmin": _vm.isAdmin,
      "isCreating": _vm.isCreating,
      "isCreated": _vm.isCreated
    },
    on: {
      "done": _vm.done,
      "changed": function($event) {
        _vm.dirtyModal(true)
      },
      "saved": _vm.savedStep
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e7e8ac5","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/groups/settings/Settings.vue
// module id = sXQb
// module chunks = 0 1